import styled from '@olxui/core/dist/theme/styled';
import { Tooltip } from '@olxui/core/dist/core/Tooltip';

export const StyledTooltip = styled(Tooltip)`
    --bgColor: ${({ theme }) => theme.colors['background-brand-tooltip']};
` as typeof Tooltip;

export const StyledGreenBgTooltip = styled(Tooltip)`
    --bgColor: ${({ theme }) => theme.colors['background-global-inverse']};
` as typeof Tooltip;
